import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getVolumeLeague, IVolumeLeagueItem} from '../../../apis/volume_league/get'

/**
 * GET /v3/volume-league (work) 조회 훅.
 * 기존 useQueryVolumeLeagues(admin/volume-leagues) 대체용.
 * 응답이 단건 객체로 올 경우에도 배열로 정규화해서 반환.
 */
const useQueryVolumeLeague = () => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.volumeLeague.getVolumeLeague(),
        queryFn: async () => {
            const {data} = await getVolumeLeague()
            const list: IVolumeLeagueItem[] = Array.isArray(data) ? data : data ? [data] : []
            return list
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    })

    return {data, refetch, isLoading}
}

export default useQueryVolumeLeague
